import { styled } from '~/styled'

import { Text } from '../text/Text'

export const StepperStepLabel = styled(Text, {
  base: ['font-semibold'],
  variants: {
    direction: {
      vertical: ['ml-3', 'text-left'],
      horizontal: ['mt-3', 'text-center']
    },
    status: {
      default: ['font-normal', 'text-grey-700'],
      active: ['text-primary-900'],
      viewed: ['text-grey-1000'],
      completed: ['text-primary-800'],
      success: ['text-success'],
      reviewed: []
    }
  }
})
